var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { LoadingContext, SkeletonLoader } from '../skeletonLoader';
import { deriveSkeletonLoaderStyle } from '../util';
/**
 * A hook that helps a component display a context-aware skeleton loader.
 *
 * Returns a React node if a skeleton loader should be displayed.
 * Otherwise, returns `null`.
 *
 * @private
 */
export function useSkeletonLoader(_a) {
    var _b = _a.loaderProps, _c = _b === void 0 ? {} : _b, loaderPropsStyle = _c.style, restLoaderProps = __rest(_c, ["style"]), loading = _a.loading, style = _a.style;
    var loadingContext = React.useContext(LoadingContext);
    var skeletonLoaderStyle = React.useMemo(function () {
        if (!style)
            return loaderPropsStyle;
        return __assign(__assign({}, deriveSkeletonLoaderStyle(style)), loaderPropsStyle);
    }, [loaderPropsStyle, style]);
    // Default to the context's loading state, but allow it to be overridden at the component level.
    if (loading !== null && loading !== void 0 ? loading : loadingContext) {
        return _jsx(SkeletonLoader, __assign({ style: skeletonLoaderStyle }, restLoaderProps));
    }
    return null;
}
